import { render } from "./FormatUserName.vue?vue&type=template&id=3350dee2"
import script from "./FormatUserName.vue?vue&type=script&lang=js"
export * from "./FormatUserName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__